import { equals, expect, is, test } from "@benchristel/taste"
import { v4 } from "uuid"

let initialProfiles;
test("getOrCreateAgentId", {
  "given ID in storage, return stored ID"(){
    initialProfiles = localStorage["profiles"]

    localStorage["agentID"] = "caterpillar"
    expect(getOrCreateAgentId(()=>"butterfly"), is, "caterpillar")
    localStorage["profiles"] = initialProfiles
  },
  "given empty storage, generate ID"(){
    initialProfiles = localStorage["profiles"]

    delete localStorage["agentID"]
    expect(getOrCreateAgentId(()=>"butterfly"), is, "butterfly")
    localStorage["profiles"] = initialProfiles
  },
  "given empty storage, store ID"(){
    initialProfiles = localStorage["profiles"]

    delete localStorage["agentID"]
    getOrCreateAgentId(()=>"grasshopper")
    expect(localStorage["agentID"], is, "grasshopper")
    localStorage["profiles"] = initialProfiles
  },
  "given an ID in storage, adds it to PROFILES"(){
    initialProfiles = localStorage["profiles"]

    localStorage["agentID"] = "cupcake"
    getOrCreateAgentId(()=>"lava")
    expect(JSON.parse(localStorage["profiles"]), equals, ["cupcake"])
    localStorage["profiles"] = initialProfiles
  }
})

export function getOrCreateAgentId(uuid:()=>string=v4) {
  const agentID = localStorage["agentID"] ||= uuid()
  localStorage["profiles"] = JSON.stringify([agentID])
  return (agentID)
}
